import script from "./InputSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSelector.vue?vue&type=script&setup=true&lang=js"

import "./InputSelector.vue?vue&type=style&index=0&id=dfac4f00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfac4f00"]])

export default __exports__